import React, { useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  API_URL,
  STORAGE_URL,
  BannerStatus,
  Preferences,
} from 'commons/constants/KeyFlowConstants';
import { RootState, PreferenceState } from 'redux/reducers/type';
import { requestPreferenceByBanner } from 'redux/actions/actions';

function usePreference() {
  const dispatch = useDispatch();

  const { preferences } = useSelector((state: RootState): PreferenceState => state.preference);

  const onRequestPreferenceByBanner = useCallback(() => {
    dispatch(requestPreferenceByBanner());
  }, [dispatch]);

  return useMemo(() => {
    const videoPartialMinTime = preferences?.videoLibrary?.get(
      Preferences.fieldNames.VIDEO_PARTIAL_MIN_TIME,
    )?.value;

    const videoPartialMaxTime = preferences?.videoLibrary?.get(
      Preferences.fieldNames.VIDEO_PARTIAL_MAX_TIME,
    )?.value;

    const webBannerFilePath = preferences?.banner
      ?.get(Preferences.fieldNames.WEB_BANNER_FILE_PATH)
      ?.toStringValue.replace(/^\/|\/$/g, '');

    const mobileBannerFilePath = preferences?.banner
      ?.get(Preferences.fieldNames.MOBILE_BANNER_FILE_PATH)
      ?.toStringValue.replace(/^\/|\/$/g, '');

    const useBanner = preferences?.banner?.get(Preferences.fieldNames.USE_BANNER)?.toNumberValue;

    return {
      videoPartialMinTime: Number(videoPartialMinTime) || 3,
      videoPartialMaxTime: Number(videoPartialMaxTime) || 300,
      useBanner: useBanner === BannerStatus.AVAILABLE,
      webBannerFilePath: `${STORAGE_URL}/${webBannerFilePath}`,
      mobileBannerFilePath: `${STORAGE_URL}/${mobileBannerFilePath}`,
      onRequestPreferenceByBanner,
    };
  }, [preferences, onRequestPreferenceByBanner]);
}

export default usePreference;
